export default {
    'diagram3b1-1': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why?',
            'checkbox-2': 'How can it?',
            'checkbox-3': 'How do you know it can?',
        },
        'elements': {
            'one': 'Bentham can cut operating costs close to $1 million a year',
            'two': 'More strictly control stock levels',
            'three': 'Streamline central functional activities',
            'four': 'Close the Melbourne wholesale news agency',
            'five': 'Restructure headquarters to focus on store efficiency',
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram1/i18n/en.js